<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row justify="space-between">
          <v-col md="2">
            <v-text-field
              v-model="filter.search"
              placeholder="Поиск по ФИО"
              dense
            />
          </v-col>
          <v-col md="3">
            <Select
                label="Присутствие:"
                v-model="filter.is_inside"
                :items="is_inside"
                item-text="name"
                item-value="id"
                class="fs-admin-complex-autocomplete"
                blank
                dense
                flat
            />
          </v-col>
          <v-col v-if="statistics" md="7">
            <v-row>
              <v-col md="6">
                <ul>
                  <li>Сотрудников в школе: {{ statistics.teachers.in_unit }}</li>
                  <li>Выдано карт сотрудникам: {{ statistics.teachers.all_cards }}</li>
                  <li>Сотрудников с картой: {{ statistics.teachers.with_card }}</li>
                  <li>Всего сотрудников: {{ statistics.teachers.all }}</li>
                </ul>
              </v-col>
              <v-col md="6">
                <ul>
                  <li>Всего в школе: {{ statistics.users.in_unit }}</li>
                  <li>Всего выдано карт: {{ statistics.users.all_cards }}</li>
                  <li>Всего с картой: {{ statistics.users.with_card }}</li>
                  <li>Всего пользователей: {{ statistics.users.all }}</li>
                </ul>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <Table
              :headers="headers"
              :items="teacherList"
              :items-per-page="teachersPerPage"
              :server-items-length="totalTeachers"
              :page="page"
              :loading="loading"
              disable-sort
              @update:request="updateRequest"
              class="elevation-1"
            >
            <template v-slot:item.is_person_inside="{ item }">
              <v-icon v-if="item.is_person_inside">check</v-icon>
              <v-icon v-else>cancel</v-icon>
            </template>
            <template v-slot:item.cards="{ item }">
              <span v-for="(card, index) in item.cards" :key="card.number">
                {{ card.number }}{{ item.cards.length - 1 > index ? ', ' : ''}}
              </span>
            </template>
            <template v-slot:item.edit="{ item }">
              <v-btn icon x-small @click="openTeacherInfoModal(item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            </Table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <Modal
      v-if="modals.teacherInfo"
      :dialog.sync="modals.teacherInfo"
      title="Информация о сотруднике"
      contentClass="esh-theme adminModal"
      btnText="Готово"
      btnIcon="done_all"
      :width="600"
    >
      <template #body>
        <v-card outlined class="infoBody">
          <v-col>
            <div class="title">
              <v-icon>account_circle</v-icon>
              {{ selectedTeacher.full_name }}
            </div>
          </v-col>
          <v-col>
            <v-divider class="mb-3" />
            <div v-for="card in selectedTeacher.cards" :key="card.id">
              <CardInfoView
                :card="card"
                @card:edit="openCardModal(card)"
              />
            </div>
              <v-alert
                v-if="!selectedTeacher.cards.length"
                outlined
                type="warning"
                dense
                class="mt-3"
              >
                Сотруднику не выдана карта
              </v-alert>
              <v-btn
                v-if="teacherCanAddNewCard"
                @click="modals.teacherNewCard = true"
              >
                Выдача новой карты
              </v-btn>
          </v-col>
        </v-card>
      </template>
    </Modal>
    <EditCardModal
      :card.sync="selectedCard"
      :showCardModal.sync="modals.teacherCardEdit"
      @onSaveEditedCard="onSaveEditedCard"
      :editCard="EDIT_CARD"
      :blockCard="BLOCK_CARD"
      :unlockCard="UNLOCK_CARD"
    />
    <NewCardModal
      :showCardModal.sync="modals.teacherNewCard"
      :user="selectedTeacher"
      @card:save="createCard($event)"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { Modal, Table, Select } from '@/components/common'
import EditCardModal from '@/components/cards/EditCardModal'
import CardInfoView from '@/components/cards/CardInfoView'
import NewCardModal from '@/components/cards/NewCardModal'
import {
  GET_ADMIN_TEACHERS,
  GET_ADMIN_STATISTICS,
  EDIT_CARD,
  BLOCK_CARD,
  UNLOCK_CARD,
  CREATE_CARD
} from '@/requests/admin'

export default {
  name: 'Teachers',
  components: {
    Modal,
    EditCardModal,
    Table,
    CardInfoView,
    NewCardModal,
    Select,
  },
  data() {
    return {
      EDIT_CARD,
      BLOCK_CARD,
      UNLOCK_CARD,
      headers: [
        { text: 'Присутстствие', value: 'is_person_inside' },
        { text: 'ID', value: 'person_id' },
        { text: 'ФИО', value: 'full_name' },
        { text: 'Карты', value: 'cards' },
        { text: 'Редактирование', value: 'edit' }
      ],
      selectedTeacher: {},
      selectedCard: {},
      teacherList: [],
      page: 1,
      teachersPerPage: BASE.LIMIT,
      totalTeachers: 0,
      loading: false,
      statistics: null,
      modals: {
        teacherInfo: false,
        teacherCardEdit: false,
        teacherNewCard: false
      },
      filter: {
        search: '',
        is_inside: null
      },
      is_inside: [
        { id: null, name: '-' },
        { id: true, name: 'В школе' },
        { id: false, name: 'Не в школе' }
      ]
    };
  },
  created() {
    this.getData()
    this.loadStatistics()
  },
  watch: {
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchTeachers()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchTeachers()
      }
    },
    'filter.is_inside': function() {
      this.searchTeachers()
    }
  },
  computed: {
    teacherCanAddNewCard() {
      if (this.selectedTeacher) {
        if (!this.selectedTeacher.cards.length) return true
        const activeCard = this.selectedTeacher.cards.find(c => !c.is_expired && !c.is_blocked)
        return !activeCard
      }
      return false
    }
  },
  methods: {
    searchTeachers: debounce(function() {
      this.page = 1
      this.getData()
    }, 300),
    openTeacherInfoModal(teacher) {
      this.selectedTeacher = teacher;
      this.modals.teacherInfo = true;
    },
    openCardModal(card) {
      this.selectedCard = card
      this.modals.teacherCardEdit = true
    },
    onSaveEditedCard(card) {
      Object.keys(this.selectedCard).forEach(key => this.selectedCard[key] = card[key])
      this.selectedCard= {}
    },
    updateRequest({ page, itemsPerPage, offset }) {
      this.teachersPerPage = itemsPerPage
      this.page = page
      this.getData({ offset })
    },
    async getData(params = {}) {
      try {
        this.loading = true
        let { data: { results, count } } = await GET_ADMIN_TEACHERS({
          limit: this.teachersPerPage,
          full_name: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : '',
          is_inside: this.filter.is_inside,
          ...params
        })

        this.teacherList = results
        this.totalTeachers = count
      } catch (error) {
        this.$$notify({
          type: 'error',
          text: 'Не удалось загрузить список сотрудников'
        })
      } finally {
        this.loading = false
      }
    },
    async loadStatistics() {
      try {
        let { data } = await GET_ADMIN_STATISTICS()
        this.statistics = data
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить статистику по школе'
        })
      }
    },
    async createCard(card) {
      try {
        const { data } = await CREATE_CARD(card)
        this.selectedTeacher.cards.unshift(data)
        this.$notify({
          type: 'success',
          text: `Карта №${card.number} успешно создана!`
        })
      } catch(error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось создать новую карту'
        })
      }
    }
  }
}
</script>
